const dragdrop = require('./customizer/dragdrop');
const builder = require('./builder-componenets');
const fieldManager = require('./customizer/fields');
const sectionManager = require('./customizer/sections');
const propertiesManager = require('./customizer/properties');
const columnTabs = require('./customizer/columnTabs');
let selectValues = [];

$(document).ready(function ($) {

    fieldManager.createNewFields();

    hideNotifications();

    dragdrop.tableBuilderDragnDrop();
    dragdrop.registerFormulaBuilderEvents()
    columnTabs.registerEvents();

    sectionManager.addNewSection();
    sectionManager.bindPropsToNewSection();
    sectionManager.getClickedSectionProps();
    sectionManager.orderSection();

    // Invoke addOptionsToSelect()
    addOptionsToSelect();
    // Invoke showFieldsDataInProps
    fieldManager.handleFieldClick();
    // Invoke bindPropsDataToFields()
    bindPropsDataToFields();

    fieldManager.orderFields();
    // Invoke orderOptions()
    orderOptions();
    // Invoke deleteOption()
    deleteOption();
    // Invoke getClickedFieldProps()
    //Is Primary Master show on relation field
    // showrelationFields();

    propertiesManager.showRelatedTableFields();
    propertiesManager.fieldMapping();
    propertiesManager.handleAlertChanges();

    let selElms = $('.builder-main').find('select');
    selElms.each(function () {
        let arrVal = $(this).data('values');
        $(this).data('values', arrVal);
    });

    let checkboxElms = $('.builder-main').find('input[type="checkbox"]');
    checkboxElms.each(function () {
        let arrVal = $(this).data('values');
        $(this).data('values', arrVal);
    });

    let radioElms = $('.builder-main').find('input[type="radio"]');
    radioElms.each(function () {
        let arrVal = $(this).data('values');
        $(this).data('values', arrVal);
    });

    let relFieldsElms = $('.builder-main').find('input[type="search"]');
    relFieldsElms.each(function () {
        let arrVal = $(this).data('relfields');
        $(this).data('relfields', arrVal);
    });

    $('body').on('colorpickerChange', '.change_option', function (event) {
        let background_color = event.color.toString(),
            $activeField = $('.activeField'),
            colors = [];

        $(this).attr('data-color', background_color);
        $('.change_option').each(function (i, input) {
            colors.push($(input).attr('data-color'));
            console.log($(input).attr('data-color'));
        });
        if ($($activeField).prop("tagName") === "DIV") {
            $($activeField).find('.fieldItem').attr('data-option-colors', JSON.stringify(colors));
        } else {
            $activeField.attr('data-option-colors', JSON.stringify(colors));
        }
    });

    $('body').on('colorpickerChange', '.btn-text-color', function (event) {
        let background_color = event.color.toString(),
            $activeField = $('.activeField');
        $activeField.data('btn-text-color', background_color).attr('data-btn-text-color', background_color);
    });

    $('body').on('colorpickerChange', '.btn-color', function (event) {
        let background_color = event.color.toString(),
            $activeField = $('.activeField');
        $activeField.data('btn-color', background_color).attr('data-btn-color', background_color);
    });
});

// Hide Notifications
function hideNotifications() {

    const notiAler = $('.cu-alert');

    $('body').on('click', '.alertControle', function (e) {
        e.preventDefault();
        $(this).parent().hide();
    })

    setTimeout(function (e) {
        notiAler.hide('fast')
    }, 2500)
}

function showrelationFields() {
    // $(document).on('change', '.relation_type', function () {
    //
    //     var reltype = $(this).val();
    //     let activeElm = $('body').find('input.activeField');
    //     if (reltype == 'masterdetail') {
    //         $('.on_show_relation').show();
    //         $('#isReq').attr('checked', true);
    //         $('#isReq').attr('disabled', true);
    //         activeElm.data('required', 1);
    //
    //     } else {
    //         $('.on_show_relation').hide();
    //         $('#isReq').attr('checked', false);
    //         activeElm.data('required', 0);
    //         $('#isReq').removeAttr('disabled');
    //     }
    // });
}

// Save Properties Data to main builder fields
function bindPropsDataToFields() {
    $(document).on('change', '.single-prop', function () {
        let activeparent = $('body').find('.activeField').closest('.section-field-container');
        let seltype = $(this).val();
        let activeElm = $('body').find('.activeField');
        let activePrentElm = $('body').find('.activeField').find('input:first-child');
        let activeField = (activeElm.hasClass('fieldItem')) ? activeElm : activeElm.find('.fieldItem');
        let id = activeField.attr('data-id');
        let order = activeField.attr('data-order');
        let label = $('.propsField[data-field="label"]').val();
        let name = $('.propsField[data-field="name"]').val();
        let selectField = $('body').find('.selectField');
        let selectOption = [];
        selectField.each(function (e) {
            selectOption.push($(this).val());
        });

        if (label === 'Untitled') {
            label = '';
        }

        if (seltype === 'radio') {
            activeparent.html('');
            activeparent.replaceWith(builder.getFieldData('radio', order, label, name, selectOption, id));
            let activeElinner = $('body').find('.activeField input[type="radio"]');
            activeElinner.data('type', seltype);
            $('.change_option').colorpicker({
                format: "hex",
                autoInputFallback: false,
                useAlpha: true
            });
            let $input = $('.change_option').find('input');
            $($input).val('#0162A7').trigger('change');
        } else if (seltype === 'select') {
            activeparent.html('');
            activeparent.replaceWith(builder.getFieldData('select', order, label, name, selectOption, id));
            activeElm.data('type', seltype);
            $('.change_option').colorpicker({
                format: "hex",
                autoInputFallback: false,
                useAlpha: true
            });
            let $input = $('.change_option').find('input');
            $($input).val('#0162A7').trigger('change');
        } else if (seltype === 'multiselect') {
            activeparent.html('');
            activeparent.replaceWith(builder.getFieldData('multiselect', order, label, name, selectOption, id));
            activeElm.data('type', seltype);
        } else if (seltype === 'multipleselect') {
            activeparent.html('');
            activeparent.replaceWith(builder.getFieldData('multipleselect', order, label, name, selectOption, id));
            activeElm.data('type', seltype);
        } else if (seltype === 'lookup' || seltype === 'masterdetail') {
            activeElm.data('related-type', seltype);
            activeElm.attr('data-related-type', seltype);
        }

        $('.propsField').keyup();
    });
    // On Change
    $(document).on('click', '.related_Fields .cust-checkbox', function () {
        let activeElm = $('body').find('.activeField');
        let selectOption = [];
        let selectField = $('body').find('.related_Fields li input[type="checkbox"]:checked');
        selectField.each(function (e) {
            selectOption.push($(this).val());
        });
        activeElm.data('relfields', selectOption).attr('data-relfields', JSON.stringify(selectOption));

    });

    $(document).on('change', '.propsChange', function (e) {

        let activeElm = $('body').find('.activeField');
        let field = $(this).data('field');
        let seltype = $(this).val();
        let $subElm = activeElm.find('input.fieldItem');

        console.log($subElm);

        switch (field) {
            case 'date-time':
                activeElm.data('type', $(this).val());
                activeElm.data('data-type', $(this).val());
                break;
            case 'required' :
                let fieldType = activeElm.find('input').prop('type');
                let activeElinner = $('body').find('.activeField input:first-child');

                if ($(this).is(":checked")) {
                    if (fieldType === 'radio' || fieldType === 'checkbox') {
                        activeElm.find('.fieldItem').data('required', 1).attr('data-required', 1);
                    }
                    if (!activeElm.prev().find('.text-danger').length) {
                        activeElm.prev().append('<span class="text-danger"> * </span>');
                    }
                    activeElm.data('required', 1).attr('data-required', 1);
                } else {
                    if (fieldType === 'radio' || fieldType === 'checkbox') {
                        activeElm.find('.fieldItem').data('required', 0).attr('data-required', 0);
                    }
                    activeElm.prev().find('span').remove();
                    activeElm.data('required', 0).attr('data-required', 0);
                }
                break;
            case 'nonzero' :
                if ($(this).is(":checked")) {
                    activeElm.data('nonzero', 1).attr('data-nonzero', 1);
                } else {
                    activeElm.data('nonzero', 0).attr('data-nonzero', 0);
                }
                break;
            case 'scanner' :
                if ($(this).is(":checked")) {
                    activeElm.attr('data-scanner', 1)
                } else {
                    activeElm.attr('data-scanner', 0)
                }
                break;
            case 'unique' :
                if ($(this).is(":checked")) {
                    activeElm.data('unique', 1)
                } else {
                    activeElm.data('unique', 0)
                }
                break;
            case 'capital' :
                if ($(this).is(":checked")) {
                    activeElm.data('capital', 1).attr('data-capital', 1);
                } else {
                    activeElm.data('capital', 0).attr('data-capital', 0);
                }
                break;

            case 'default' :
                if ($(this).is(":checked")) {
                    activeElm.data('default', 'yes')
                } else {
                    activeElm.data('default', 'no')
                }
                break;
            case 'related-to' :
                activeElm.data('related', 1);
                activeElm.data('relid', $(this).val());
                break;
            case 'primary-column' :
                activeElm.data('primary-column', $(this).val());
                activeElm.attr('data-primary-column', $(this).val());
                break;
            case 'automation-id' :
                activeElm.data('automation-id', $(this).val());
                activeElm.attr('data-automation-id', $(this).val());
                break;
            case 'filter-column' :
                activeElm.data('filter-column', $(this).val());
                activeElm.attr('data-filter-column', $(this).val());
                break;
            case 'related-field-filter' :
                activeElm.data('related-filter', $(this).val());
                activeElm.attr('data-related-filter', $(this).val());
                break;
            case 'number-type' :
                activeElm.data('type', $(this).val());
                activeElm.attr('data-type', $(this).val());
                break;
            case 'height':
                if($subElm.length){
                    activeElm = $subElm;
                }
                activeElm.data('height', $(this).val());
                activeElm.attr('data-height', $(this).val());
                break;
            case 'width':
                if($subElm.length){
                    activeElm = $subElm;
                }
                activeElm.data('width', $(this).val());
                activeElm.attr('data-width', $(this).val());
                break;
            case 'auto_field_type':
                activeElm.data('auto-type', $(this).val());
                activeElm.attr('data-auto-type', $(this).val());
                break;
            case 'view_only':
                if ($(this).is(":checked")) {
                    activeElm.data('view-only', 1)
                    activeElm.attr('data-view-only', 1);
                } else {
                    activeElm.data('view-only', 0);
                    activeElm.attr('data-view-only', 0);
                }
                break;
            case 'speech_to_text':
                if ($(this).is(":checked")) {
                    activeElm.data('speech-to-text', 1)
                    activeElm.attr('data-speech-to-text', 1);
                } else {
                    activeElm.data('speech-to-text', 0);
                    activeElm.attr('data-speech-to-text', 0);
                }
                break;
            case 'enable_pattern' :
                if ($(this).is(":checked")) {
                    $('.propsField[data-field="pattern"]').prop('disabled', false);
                    activeElm.data('pattern-enabled', 1);
                    activeElm.attr('data-pattern-enabled', 1);
                } else {
                    $('.propsField[data-field="pattern"]').prop('disabled', true);
                    activeElm.data('pattern-enabled', 0);
                    activeElm.attr('data-pattern-enabled', 0);
                }
                break;
        }
    });

    // On Keyup
    $('body').on('keyup', '.propsField', function () {
        let insidefield = $('body').find('.activeField .custom-checkbox input[type="radio"]');
        let inside_multicheckbox_field = $('body').find('.activeField .custom-checkbox input[type="checkbox"]');
        let findparent_active = $('body').find('.activeField');
        let activeElm = $('body').find('.activeField');
        let field = $(this).data('field');
        let value = $(this).val();
        let required = activeElm.data('required');
        let vl = value.replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();

        switch (field) {
            case 'formula':
                if (value.length) {
                    activeElm.attr('data-value', value);
                }
                break;

            case 'default_value':
                activeElm.attr('data-value', value);
                break;
            case 'label' :
                if (activeElm.prev('label').length) {
                    activeElm.prev('label').text(value);

                    if (required) {
                        activeElm.prev('label').append('<span class="text-danger"> * </span>');
                    }

                    if (activeElm.hasClass('is-button')) {
                        activeElm.text(value);
                    }

                    let name = $(this).parents('.propertiesContent').find('[data-field="name"]');

                    if (!name.is('[readonly]') && !activeElm.data('id')) {

                        if (tenant !== 'default' && vl.length && !vl.endsWith('_c')) {
                            vl = `${vl}_c`;
                        }

                        name.val(vl);
                        activeElm.data('name', vl).attr('data-name', vl);

                        let $existing = $(`.fieldItem[data-name="${vl}"]`);
                        if($existing.length > 1){
                            $('.propsField[data-field="name"]').next('.invalid-feedback').remove();
                            $('.propsField[data-field="name"]').addClass('is-invalid')
                                .after(`<div class="invalid-feedback">Field with name ${vl} already exist</div>`);
                        }else{
                            $('.propsField[data-field="name"]').removeClass('is-invalid').next('.invalid-feedback').remove();
                        }
                    }

                } else {
                    activeElm.find('.multioptionslabel').text(value)
                    activeElm.find('input').eq(0).data('label', value)
                }

                if (findparent_active.find('label:first').length) {

                    findparent_active.find('label:first').text(value)

                    if (required) {
                        findparent_active.find('label:first').append('<span class="text-danger"> * </span>');
                    }
                    ///for picklist radio button
                    insidefield.data('name', vl)

                    activeElm.find('.multipicklist_data').data('lblname', value);
                    ///for multipicklist checkbox button
                    inside_multicheckbox_field.data('name', vl)

                    let name = $(this).parents('.propertiesContent').find('[data-field="name"]');

                    if (!name.is('[readonly]') && !activeElm.find('.fieldItem').data('id')) {

                        if (tenant !== 'default' && vl.length && !vl.endsWith('_c')) {
                            vl = `${vl}_c`;
                        }
                        activeElm.find('.multipicklist_data').data('fieldname', vl).attr('data-fieldname', vl);
                        activeElm.find('.fieldItem').data('name', vl).attr('data-name', vl);
                        name.val(vl);
                    }

                } else {
                    ///for picklist radio button
                    insidefield.find('.multioptionslabel').text(value)
                    insidefield.find('input').eq(0).data('label', value)
                    ///for multipicklist checkbox button
                    inside_multicheckbox_field.find('.multioptionslabel').text(value)
                    inside_multicheckbox_field.find('input').eq(0).data('label', value)
                }

                activeElm.data('label', value);
                insidefield.data('label', value);
                inside_multicheckbox_field.data('label', value);

                break;
            case 'hint' :
                activeElm.prop('placeholder', value);
                activeElm.data('hint', value);
                activeElm.attr('data-hint', value);
                if ($(activeElm).prop("tagName") === "DIV") {
                    $(activeElm).find('.fieldItem').data('hint', value).attr('data-hint', value);
                }
                break;
            case 'pattern' :
                activeElm.data('pattern', value);
                activeElm.attr('data-pattern', value);
                break;
            case 'message' :
                activeElm.data('message', value);
                activeElm.attr('data-message', value);
                break;
            case 'name' :
                activeElm.data('name', vl).attr('data-name', vl);
                insidefield.data('name', vl).attr('data-name', vl);
                inside_multicheckbox_field.data('name', vl).attr('data-name', vl);
                $(this).val(vl);

                let label = $('.propertiesContent').find('[data-field="label"]').val(),
                    lbl_value = label.replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();

                if (!$(this).is('[readonly]') && !activeElm.data('id')) {
                    if (tenant !== 'default' && vl.length && !vl.endsWith('_c')) {
                        lbl_value = `${lbl_value}_c`;
                        $(this).val(lbl_value);
                    }
                }

                break;
            case 'values' :
                let opOrder = activeElm.parents('.fieldsSection').find('.fieldItem').length;
                let getIndex = $('.options-blocks .propsField').index(this);
                let input = activeElm.find('input').eq(getIndex);
                if (activeElm.find('input').data('type') === 'multiselect' || activeElm.find('input').data('type') === 'radio') {
                    let i = getIndex + 1;
                    input = activeElm.find('input').eq(i);
                }
                if (activeElm.find('input').data('type') === 'checkbox' ||
                    activeElm.find('input').data('type') === 'radio' ||
                    activeElm.find('input').data('type') === 'multiselect'
                ) {
                    input.next('label').text(value)
                    input.data('label', value).attr('data-label', value);
                    input.data('name', vl).attr('data-name', vl);
                    input.data('order', opOrder - 1).attr('data-order', opOrder - 1);
                    input.data('value', value).attr('data-value', value);
                }
                break;
        }
    });

    // On Blur Select Input
    $('body').on('change keyup', '.selectField', function () {

        let activeElm = $('body').find('.activeField');
        let selectElm = $('body').find('.activeField').find('input[type="radio"]');
        let multicheckElm = $('body').find('.activeField').find('input[type="checkbox"]');

        let field = $(this).data('field');

        if (field === 'values' && (
            activeElm.data('field') === 'select' ||
            selectElm.data('field') === 'radio' ||
            multicheckElm.data('field') === 'multiselect' ||
            activeElm.data('field') === 'multipleselect'
        )
        ) {

            let selectOption = [];
            let selectField = $('body').find('.selectField');
            selectField.each(function (e) {
                selectOption.push($(this).val());
            });
            activeElm.data('values', selectOption);
            selectElm.data('values', selectOption);
            multicheckElm.data('values', selectOption);
        }

    })

}

// Add options to Props and bind them to select/multi select field
function addOptionsToSelect() {
    $('body').on('click', '.option-btn', function (e) {

        let value = $('body').find('.option-control').val(),
            colors = '';

        if (!$('.options-blocks').hasClass('multipleOptions')) {
            colors = `
                <div class="input-group-append change_option" style="margin-left: 10px;">
                    <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                    <span class="input-group-append">
                        <span class="input-group-text colorpicker-input-addon"><i></i></span>
                    </span>
                </div>`;
        }

        let content = `

        <div class="input-group mb-1 option-block">

            <div class="input-group-prepend">
                <span class="input-group-text orderSelectopt">
                    <i class="fas fa-arrows-alt"></i>
                </span>
            </div>

            <input
                type="text"
                class="form-control propsField selectField"
                data-field="values"
                value="${value}">

            <div class="input-group-append">
                <span class="input-group-text deleteSelectopt">
                    <i class="fas fa-times"></i>
                </span>
            </div>
            ${colors}
        </div>`;

        $(content).appendTo('.options-blocks');

        $('.change_option').colorpicker({
            format: "hex",
            autoInputFallback: false,
            useAlpha: true
        });

        let $input = $('.change_option').find('input');
        $($input[$input.length - 1]).val('#FFFFFF').trigger('change');

        $('body').find('.option-control').val('');
        let optionsBlocks = $(this).parents().siblings('.options-blocks');

        if (optionsBlocks.hasClass('selectOptions')) {
            let activeElm = $('body').find('.activeField');
            // When adding new value we'll empty the select array and add value to it again!
            let selectOption = [];
            let selectField = $('body').find('.selectField');
            selectField.each(function (e) {
                selectOption.push($(this).val());
            })

            activeElm.data('values', selectOption);

        } else if (optionsBlocks.hasClass('multiselectOptions')) {
            let activeElm = $('body').find('.activeField');
            // When adding new value we'll empty the select array and add value to it again!
            let selectOption = [];
            let selectField = $('body').find('.selectField');
            selectField.each(function (e) {
                selectOption.push($(this).val());
            })

            activeElm.data('values', selectOption);

        } else if (optionsBlocks.hasClass('selectradio')) {
            let selectElm = $('body').find('.activeField').find('input[type="radio"]');
            // When adding new value we'll empty the select array and add value to it again!
            let selectOption = [];
            let activeElm = $('body').find('.activeField');
            let selectField = $('body').find('.selectField');
            let opOrder = activeElm.parents('.fieldsSection').find('.fieldItem').length;
            let content = `

            <div class="custom-control custom-checkbox"> 
                <input 
                type="hidden"
                data-order="${opOrder - 1}" 
                disabled>
                <label class="custom-control-label">${value}</label>
            </div> 
            `;
            activeElm.append(content);

            selectField.each(function (e) {
                selectOption.push($(this).val());
            })
            selectElm.data('values', selectOption);
        } else if (optionsBlocks.hasClass('multipleOptions')) {
            let selectElm = $('body').find('.activeField').find('input[type="checkbox"]');
            // When adding new value we'll empty the select array and add value to it again!
            let selectOption = [];
            let activeElm = $('body').find('.activeField');
            let selectField = $('body').find('.selectField');
            let opOrder = activeElm.parents('.fieldsSection').find('.fieldItem').length;
            let content = `
            <div class="custom-control custom-checkbox"> 
                <input 
                type="hidden"
                data-order="${opOrder - 1}" 
                disabled>
                <label class="custom-control-label">${value}</label>
            </div> 
            `;

            activeElm.append(content);

            selectField.each(function (e) {
                selectOption.push($(this).val());
            });
            selectElm.data('values', selectOption);

        } else {

            let activeElm = $('body').find('.activeField');
            let opOrder = activeElm.parents('.fieldsSection').find('.fieldItem').length;

            let content = `

            <div class="custom-control custom-checkbox"> 
                <input 
                type="hidden"
                data-order="${opOrder - 1}" 
                disabled>
                <label class="custom-control-label">${value}</label>
            </div> 

            `;
            activeElm.append(content)

        }


    })

}

// Delete Option
function deleteOption() {

    let propsTab = $('.propertiesTabHeader');
    let propsContent = $('.propertiesContent');
    let fieldsContent = $('.fieldsContent');

    $('body').on('click', '.deleteSelectopt', function () {

        let activeElm = $('body').find('.activeField');
        let getIndex = $('.options-blocks .deleteSelectopt').index(this);
        if ($(this).parents('.options-blocks').hasClass('selectOptions')) {
            let value = $(this).parent().prev().val(),
                ind = selectValues.indexOf(value);

            selectValues.splice(ind, 1);
            $(this).parents('.option-block').remove();
            let selectOption = [];
            let selectElm = $('body').find('.activeField');
            let selectField = $('body').find('.selectField'),
                colors = [];

            selectField.each(function (e) {
                selectOption.push($(this).val());
            });

            $('.change_option').each(function (i, input) {
                colors.push($(input).attr('data-color'));
            });

            selectElm.data('values', selectOption).attr('data-values', JSON.stringify(selectOption));
            selectElm.data('option-colors', colors).attr('data-option-colors', JSON.stringify(colors));

        } else if ($(this).parents('.options-blocks').hasClass('multiselectOptions')) {
            let value = $(this).parent().prev().val();
            let ind = selectValues.indexOf(value);

            selectValues.splice(ind, 1);
            $(this).parents('.option-block').remove();
            let selectOption = [];
            let selectElm = $('body').find('.activeField');
            let selectField = $('body').find('.selectField');

            selectField.each(function (e) {
                selectOption.push($(this).val());
            });

            selectElm.data('values', selectOption);


        } else if ($(this).parents('.options-blocks').hasClass('selectradio')) {
            let value = $(this).parent().prev().val();
            let ind = selectValues.indexOf(value);

            selectValues.splice(ind, 1);
            $(this).parents('.option-block').remove();
            let selectOption = [];
            let selectElm = $('body').find('.activeField').find('input[type="radio"]');
            let selectField = $('body').find('.selectField');

            selectField.each(function (e) {
                selectOption.push($(this).val());
            });

            selectElm.data('values', selectOption);

            $(this).parents('.option-block').remove();
            activeElm.find('.custom-control').eq(getIndex).remove()


        } else if ($(this).parents('.options-blocks').hasClass('multipleOptions')) {
            let value = $(this).parent().prev().val();
            let ind = selectValues.indexOf(value);

            selectValues.splice(ind, 1);
            $(this).parents('.option-block').remove();
            let selectOption = [];
            let selectElm = $('body').find('.activeField').find('input[type="checkbox"]');
            let selectField = $('body').find('.selectField');

            selectField.each(function (e) {
                selectOption.push($(this).val());
            });

            selectElm.data('values', selectOption);

            $(this).parents('.option-block').remove();
            activeElm.find('.custom-control').eq(getIndex).remove()

        } else {

            $(this).parents('.option-block').remove();
            activeElm.find('.custom-control').eq(getIndex).remove()

            if (activeElm.find('.custom-control').length == 0) {

                activeElm.parents('.section-field-container').remove();
                propsContent.html('')
                propsContent.hide()
                propsTab.hide()
                fieldsContent.show()
            }
        }

    })
}


// Make The Options values Sortable
function orderOptions() {
    $(".builder-right-side").sortable({
        items: '.option-block',
        update: function (e, ui) {
            let selectOption = [];
            let selectField = $('body').find('.selectField');
            let selectElm = $('body').find('.activeField');
            if (!selectElm.hasClass('fieldItem')) {
                if ($('body').find('.activeField').find('input[type="checkbox"]').length) {
                    selectElm = $('body').find('.activeField').find('input[type="checkbox"]');
                } else {
                    selectElm = $('body').find('.activeField').find('input[type="radio"]');
                }
            }
            selectField.each(function (e) {
                selectOption.push($(this).val());
            });
            selectElm.data('values', selectOption);
        }
    });
    $(".builder-main .option-block").disableSelection();
}
